import Vue from 'vue';
import Notifications from 'vue-notification';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import App from './app.vue';
import router from './router/router';
import './styles/index.scss';
import './filters';
import store from './store';
import './bootstrap';
import i18nPlugin from './plugins/i18n';
import veeValidateConfig from './plugins/vee-validate-config';
import sidebarPlugin from './plugins/sidebar/plugin';

// v2
import './v2/styles/index.scss';

import 'vue-easytable/libs/theme-default/index.css';
import VueEasytable, { VePagination, VeLocale } from 'vue-easytable';

Vue.prototype.$veLocale = VeLocale;
Vue.use(VueEasytable);
Vue.use(VePagination);
//

Vue.config.productionTip = false;

Vue.use(Notifications);
Vue.use(i18nPlugin, {
  resources: {
    de: {
      translation: require('./localization/de-DE.json')
    },
    en: {
      translation: require('./localization/en-EN.json')
    }
  }
});
Vue.use(veeValidateConfig);
Vue.use(sidebarPlugin);

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app');
